var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSqftFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 14.5C1.81945 14.5 1.38528 14.3228 1.03083 13.9683C0.67639 13.6139 0.499446 13.18 0.500001 12.6667V1.25C0.500001 0.847221 0.687501 0.56611 1.0625 0.406665C1.4375 0.247221 1.76389 0.30611 2.04167 0.583332L3.91667 2.45833L2.79167 3.58333L3.375 4.16667L4.5 3.04167L6.66667 5.20833L5.54167 6.33333L6.125 6.91666L7.25 5.79167L9.41667 7.95833L8.29167 9.08333L8.875 9.66667L10 8.54167L12.1667 10.7083L11.0417 11.8333L11.625 12.4167L12.75 11.2917L14.4167 12.9583C14.6944 13.2361 14.7536 13.5625 14.5942 13.9375C14.4347 14.3125 14.1533 14.5 13.75 14.5H2.33333ZM3 12H9.91667L3 5.08333V12Z",
    fill: "#969BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSqftFill);
export default __webpack_public_path__ + "static/media/icn-sqft-fill.c3620ef5db82bef7f9b7dba275df1de5.svg";
export { ForwardRef as ReactComponent };